import { Serializable } from "../utilities/Serializable";
import { TransactionType } from "./TransactionType";
import { PoS } from "./PoS";
import { Coupon } from "./Coupon";

export class CouponTransaction extends Serializable {
    uuid: string;
    date: Number;
    movement: number;
    type: TransactionType;
    pos: PoS;
    cardUuid: string;
    coupon: Coupon;
    amountSnapshot: number;
    description: string;

    constructor() {
        super();
        this.date = Date.now();
        this.movement = 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/CouponTransaction.ts